const normalizeApiBaseUrl = (baseUrl) => {
  if (!baseUrl) {
    return '/api';
  }

  const normalized = String(baseUrl).trim().replace(/\/+$/, '');
  return normalized || '/api';
};

export const getApiBaseUrl = () =>
  normalizeApiBaseUrl(process.env.REACT_APP_API_URL || '/api');

export const getServerBaseUrl = () => {
  const baseUrl = getApiBaseUrl();
  return baseUrl.replace(/\/api\/?$/, '') || '';
};

// Converts a server-relative path like /uploads/logos/x.jpg into a full URL
export const getUploadUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('blob:') || path.startsWith('data:')) return path;
  return getServerBaseUrl() + path;
};
